class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.querySelectorAll('select').length > 0) {
      this.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', this.changeHandler.bind(this));
      });
    }
  }

  disconnectedCallback() {
    if (this.querySelectorAll('select').length > 0) {
      this.querySelectorAll('select').forEach((select) => {
        select.removeEventListener('change', this.changeHandler);
      });
    }
  }

  changeHandler(e) {
    const productCard = e.target.closest('.card-wrapper');
    const variantData =
      productCard.querySelector('script.variant-data') &&
      JSON.parse(productCard.querySelector('script.variant-data').textContent);
    const selectedValues = Array.from(productCard.querySelectorAll('default-variant-picker select'), (el) => el.value);
    const currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return selectedValues[index] === option;
        })
        .includes(false);
    });
    productCard.querySelector('price-container').setProduct(currentVariant);
    productCard.querySelector('price-container').updatePrices();

    const form = productCard.querySelector('form');
    const updateCardData = (variant) => {
      productCard.dataset.variantId = variant.id;
      form.querySelector('input[name="id"]').setAttribute('value', variant.id);
      if (variant.selling_plan_allocations[0]) {
        form
          .querySelector('input[name="selling_plan"]')
          .setAttribute('value', variant.selling_plan_allocations[0].selling_plan_id);
      }
      productCard.querySelector('.card__media img.active').classList.remove('active');
      productCard.querySelector(`.card__media img[data-variant-id="${variant.id}"]`).classList.add('active');
    };

    updateCardData(currentVariant);
  }
}

customElements.define('cart-recommendations', CartRecommendations);
